type ParagraphProps = {
  headline: string
  body: string
}

const Paragraph = (props: ParagraphProps): JSX.Element => {
  return (
    <div className="top-separator flex flex-col gap-[1rem]">
      <div className="text-xl font-semibold text-dark-blue">{props.headline}</div>
      <p className="text-[1.5rem] leading-10 whitespace-pre-line">{props.body}</p>
    </div>
  )
}

export default Paragraph
